import Vue from 'vue';
import {i18n} from './plugins/i18n'
import { router } from './route/router';
import VueGtm from '@gtm-support/vue2-gtm';
import App from './App';
import Vuelidate from "vuelidate";
import VCalendar from "v-calendar";
import Heading from './components/baseComponents/Heading';
import store from './stores/index';
import CustomButton from './components/baseComponents/CustomButton'

Vue.use(VCalendar, {
})
Vue.use(Vuelidate);
Vue.use(VueGtm, {
    id: 'GTM-MX45SJV', // Your GTM single container ID/GTM-XXXXXXX
    enabled: true,
    debug: true,
});
Vue.component( "Button", CustomButton )
Vue.component( "Heading", Heading )

const data  = document.getElementById('app').dataset;

const app = new Vue({
    el: '#app',
    render: h => h(App),
    i18n,
    router,
    store: store,
    data: {
        country: data.country ?? null,
        tour: data.tour ?? null,
    }
});


